// @ts-nocheck
import useAppDispatch from "@insite/client-framework/Common/Hooks/useAppDispatch";
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import setUserFields from "@insite/client-framework/Store/Pages/UserSetup/Handlers/SetUserFields";
import { getCurrentEditingUser } from "@insite/client-framework/Store/Pages/UserSetup/UserSetupSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import useAvailableApprovers from "@store/Framework/Store/Data/Accounts/Hooks/useAvailableApprovers";
import ModalPicker from "@store/Library/Components/Reporting/ModalPicker/ModalPicker";
import useCheckboxPicker from "@store/Library/Components/Reporting/ModalPicker/useCheckboxPicker";
import React, { useEffect } from "react";

interface Props {}

const UserSettingsAdditionalApproverPicker: React.FC<Props> = () => {
    const availableApprovers = useAvailableApprovers();
    const { selectedItems, setSelectedItems, toggleAllItems, toggleItem } = useCheckboxPicker();
    const editingUser = useAppSelector(state => getCurrentEditingUser(state));

    const currentAdditionalApprovers = editingUser?.properties?.bunzl_AdditionalApprovers;
    const dispatch = useAppDispatch();
    const handleApproverChange = (items: string[]) => {
        dispatch(
            setUserFields({
                properties: { ...editingUser?.properties, bunzl_AdditionalApprovers: items.join("|") },
            } as { properties: { bunzl_AdditionalApprovers: string } } as any),
        );
    };

    useEffect(() => {
        if (!currentAdditionalApprovers || !availableApprovers) {
            setSelectedItems([]);
            return;
        }
        const selectedApproversArray = currentAdditionalApprovers.split("|");
        const filteredSelectedApprovers = selectedApproversArray.filter(approver =>
            availableApprovers.includes(approver),
        );
        setSelectedItems(filteredSelectedApprovers);
    }, [availableApprovers, currentAdditionalApprovers, setSelectedItems]);

    const handleToggleAllItems = () => {
        if (!availableApprovers) {
            return;
        }
        const newSelectedItems = toggleAllItems(availableApprovers);
        handleApproverChange(newSelectedItems);
    };
    const handleToggleItem = (item: string) => {
        const newSelectedItems = toggleItem(item);
        handleApproverChange(newSelectedItems);
    };

    if (!availableApprovers) {
        return null;
    }

    return (
        <ModalPicker
            data={availableApprovers}
            selectedItems={selectedItems}
            toggleAllItems={handleToggleAllItems}
            toggleItem={handleToggleItem}
            header={translate("Additional Approvers")}
        />
    );
};

const widgetModule: WidgetModule = {
    component: UserSettingsAdditionalApproverPicker,
    definition: {
        group: "User Setup",
        fieldDefinitions: [],
    },
};

export default widgetModule;
